import React from 'react';
import { Card, Table, Statistic, Row, Col } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccCapacity } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const CapacityUtilizationPanel: React.FC<Props> = ({ params }) => {
  const { data, isLoading } = useWccCapacity(params);
  const d = data as {
    summary?: Record<string, number>;
    ranking?: Array<Record<string, unknown>>;
  };

  return (
    <Card id="capacity" title="Capacity utilization" style={{ marginTop: 16 }} loading={isLoading}>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col><Statistic title="Available h" value={d?.summary?.total_available_hours ?? 0} /></Col>
        <Col><Statistic title="Planned h" value={d?.summary?.total_planned_hours ?? 0} /></Col>
        <Col><Statistic title="Actual h" value={d?.summary?.total_actual_hours ?? 0} /></Col>
        <Col><Statistic title="Utilization %" value={d?.summary?.average_utilization ?? 0} suffix="%" /></Col>
      </Row>
      <Table
        size="small"
        rowKey="ws"
        dataSource={d?.ranking ?? []}
        columns={[
          { title: 'Workstation', dataIndex: 'ws' },
          { title: 'Utilization %', dataIndex: 'util', width: 120 },
        ]}
        pagination={false}
      />
    </Card>
  );
};

export default CapacityUtilizationPanel;
